import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { MailCheck, RefreshCw, ArrowLeft } from "lucide-react";
import BrandLogo from "../../components/BrandLogo";

const G      = "var(--k-green)";
const G_DARK = "var(--k-green-hover)";
const API    = "https://api.komorotel.com";

// adapte cette route au nom réel côté back
const RESEND_ROUTE = (id) => `${API}/api/auth/resend/${id}`;

export default function EmailVer() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const email  = state?.email;
  const userId = state?.userId;

  const [sending,   setSending]   = useState(false);
  const [sent,      setSent]      = useState(false);
  const [error,     setError]     = useState("");
  const [countdown, setCountdown] = useState(0);

  // pas d'email en state : l'utilisateur n'est pas passé par l'inscription
  useEffect(() => {
    if (!email) navigate("/signup", { replace: true });
  }, [email, navigate]);

  // compte à rebours avant de pouvoir renvoyer
  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  const handleResend = async () => {
    if (!userId || sending || countdown > 0) return;
    setError("");
    try {
      setSending(true);
      await axios.get(RESEND_ROUTE(userId), { withCredentials: true });
      setSent(true);
      setCountdown(60);
    } catch (err) {
      setError(err.response?.data?.message || "Impossible de renvoyer l'email");
    } finally {
      setSending(false);
    }
  };

  if (!email) return null;

  return (
    <div style={{
      minHeight: "100vh", background: "#fafafa",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24, fontFamily: "'DM Sans','Inter',system-ui,sans-serif",
    }}>
      <div style={{
        width: "100%", maxWidth: 460, background: "#fff",
        border: "1px solid #f3f4f6", borderRadius: 18,
        padding: "40px 36px", textAlign: "center",
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
      }}>

        <Link to="/" style={{ display: "inline-block", marginBottom: 32 }}>
          <BrandLogo variant="horizontal" height={32} />
        </Link>

        <div style={{
          width: 62, height: 62, borderRadius: "50%",
          background: "rgb(var(--k-green-rgb)/0.1)",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 22px",
        }}>
          <MailCheck size={28} color={G} strokeWidth={2} />
        </div>

        <h1 style={{
          fontFamily: "Georgia, serif", fontSize: 23, fontWeight: 700,
          color: "#111827", marginBottom: 10,
        }}>
          Vérifiez votre boîte mail
        </h1>

        <p style={{ fontSize: 14, color: "#6b7280", lineHeight: 1.6, marginBottom: 6 }}>
          Nous avons envoyé un lien de confirmation à
        </p>
        <p style={{ fontSize: 14, fontWeight: 700, color: "#111827", marginBottom: 22 }}>
          {email}
        </p>

        <div style={{
          background: "#fafafa", border: "1px solid #f3f4f6", borderRadius: 12,
          padding: "14px 16px", fontSize: 13, color: "#6b7280",
          lineHeight: 1.6, textAlign: "left", marginBottom: 22,
        }}>
          Cliquez sur le lien pour activer votre compte. Il expire dans 6 heures.
          Pensez à regarder dans vos spams si vous ne le trouvez pas.
        </div>

        {sent && (
          <div style={{
            background: "rgb(var(--k-green-rgb)/0.08)",
            border: "1px solid rgb(var(--k-green-rgb)/0.25)",
            borderRadius: 10, padding: "10px 14px",
            fontSize: 13, color: G, marginBottom: 14,
          }}>
            Email renvoyé
          </div>
        )}

        {error && (
          <div style={{
            background: "#fef2f2", border: "1px solid #fecaca",
            borderRadius: 10, padding: "10px 14px",
            fontSize: 13, color: "#ef4444", marginBottom: 14,
          }}>
            {error}
          </div>
        )}

        {userId && (
          <button
            type="button"
            onClick={handleResend}
            disabled={sending || countdown > 0}
            style={{
              width: "100%", background: (sending || countdown > 0) ? "#d1d5db" : G,
              color: "#fff", border: "none", borderRadius: 12,
              padding: "13px 0", fontSize: 14, fontWeight: 700,
              cursor: (sending || countdown > 0) ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
              transition: "background 0.18s", marginBottom: 16,
            }}
            onMouseEnter={e => { if (!sending && countdown === 0) e.currentTarget.style.backgroundColor = G_DARK; }}
            onMouseLeave={e => { if (!sending && countdown === 0) e.currentTarget.style.backgroundColor = G; }}
          >
            <RefreshCw size={15} />
            {sending
              ? "Envoi en cours..."
              : countdown > 0
                ? `Renvoyer dans ${countdown}s`
                : "Renvoyer l'email"}
          </button>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "18px 0" }}>
          <div style={{ flex: 1, height: 1, background: "#f3f4f6" }} />
          <span style={{ fontSize: 12, color: "#9ca3af" }}>ou</span>
          <div style={{ flex: 1, height: 1, background: "#f3f4f6" }} />
        </div>

        <p style={{ fontSize: 13, color: "#6b7280" }}>
          Compte déjà activé ?{" "}
          <Link to="/login" style={{ color: G, fontWeight: 700, textDecoration: "none" }}>
            Se connecter
          </Link>
        </p>

        <Link to="/" style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          fontSize: 12, color: "#9ca3af", textDecoration: "none", marginTop: 26,
        }}>
          <ArrowLeft size={13} /> Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}